import { defineComponent as _defineComponent } from 'vue'
import { useThemeModel } from '@entities/theme'
import { useTipsModel } from './../model'
interface ITipsPercents {
  percent: number
  role: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TipsPercents',
  props: {
  data: {
    type: Object,
    required: true,
    default: () => {}
  },
  role: {
    type: String,
    required: true
  },
  sumOrders: {
    type: Number,
    required: false,
    default: 0
  }
},
  setup(__props) {

const props = __props

const tipsModel = useTipsModel()
const themeModel = useThemeModel()



const isPercentDisabled = (percent: number) => {
  if (props.sumOrders === 0 || props.sumOrders < 0) {
    return props.data.percents.includes(percent)
  }

  if (props.role === 'waiter' || props.role === 'team') {
    return (props.sumOrders / 100 * percent) < 49 && (props.sumOrders / 100 * percent) > 0
  } else {
    return Math.round((props.sumOrders / 100 * percent)) === 0 && percent !== 0
  }
}

const selectPercents = (data: ITipsPercents) => {
  const { role, percent } = data
  const sum = (props.sumOrders / 100 * percent)

  tipsModel.changeTips({
    role,
    sum,
    selectedPercent: percent,
    manualTips: false,
    hideActiveStylePercent: false
  })
}

return { __sfc: true,tipsModel, themeModel, props, isPercentDisabled, selectPercents }
}

})